import React from 'react';
import { useLocation } from 'react-router-dom';
import './AppNav.css';

const AppNav = () => {
  const location = useLocation();
  
  // No navigation links needed since we removed the demo page
  return (
    <div className="app-nav">
      {/* Navigation links removed */}
    </div>
  );
};

export default AppNav; 